(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/notifications.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/notifications.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useEffect,
  useState
} = React;
const {
  Form
} = svs.ui.reactForm;
const {
  CheckboxItem,
  TopHeader
} = svs.myProfile.react.shared.components;
const {
  trackListChanges,
  trackNotification
} = svs.myProfile.react.shared.tracking;
const {
  showCustomersOldLinkError,
  showSettingsTechnicalError
} = svs.myProfile.react.shared.dialogs;
const {
  clearAllUrlParam,
  makeSetting
} = svs.myProfile.react.shared.helpers;
const {
  syndicateMailId
} = svs.myProfile.constants;
const {
  useCustomerSettings
} = svs.myProfile.react.shared.hooks;
const {
  putCustomersSettingsAsync
} = svs.myProfile.react.shared.customerSettingsService;
const {
  setPlayerSettingsData
} = svs.myProfile.react.store.pd.actions;
const {
  backendName,
  titles,
  icons
} = svs.myProfile.constants;
const {
  notificationsSyndicateService,
  NotificationsSkeleton
} = svs.myProfile.react.pages.notifications;
const {
  AppNotifications
} = svs.myProfile.react.pages.notifications.appNotifications;
const {
  useSyndicate
} = svs.myProfile.react.pages.notifications.hooks;
const {
  CheckboxSyndicateItem,
  CorrectionMail,
  SyndicateInformation,
  Section,
  Marketplace
} = svs.myProfile.react.pages.notifications.components;

const Notifications = () => {
  const dispatch = ReactRedux.useDispatch();
  const cAndI = ReactRedux.useSelector(state => state.playerDetails.cAndI);
  const {
    playerSettings
  } = ReactRedux.useSelector(state => state.playerDetails);
  const [hasApiErrorShowed, sethasApiErrorShowed] = useState(false);
  const [isSyndicateMember, setIsSyndicateMember] = useState();
  const [isSyndicateOwner, setIsSyndicateOwner] = useState();
  const [playerSyndicateData, setPlayerSyndicateData] = useState();
  const [shouldShowApiError, setShouldShowApiError] = useState(false);
  const [isPlayerLoggedIn] = useState(svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER));
  useSyndicate(setPlayerSyndicateData, setIsSyndicateOwner, setIsSyndicateMember, setShouldShowApiError);
  useCustomerSettings(setShouldShowApiError);
  useEffect(() => {
    if (shouldShowApiError && !hasApiErrorShowed) {
      sethasApiErrorShowed(true);
      showSettingsTechnicalError();
    }
  }, [shouldShowApiError, hasApiErrorShowed]);
  useEffect(() => {
    const getData = async () => {
      var _svs$my_profile_react;
      svs.myProfile.logger.debug("**** Player isPlayerLoggedIn: ".concat(isPlayerLoggedIn ? 'Yes' : 'No'));
      const unInLoggedData = (_svs$my_profile_react = svs.my_profile_react.data) === null || _svs$my_profile_react === void 0 ? void 0 : _svs$my_profile_react.communication_settings_react;
      svs.myProfile.logger.debug('get svs.myProfile.data?.communication_settings_react:');
      if (unInLoggedData && unInLoggedData.dataError) {
        clearAllUrlParam();
        showCustomersOldLinkError();
      }
      if (unInLoggedData && unInLoggedData.data) {
        dispatch(setPlayerSettingsData(unInLoggedData.settings));
      }
    };
    getData();
  }, [isPlayerLoggedIn]);
  const handleCheckbox = async (id, isOverride, isEnabledOverride) => {
    svs.myProfile.logger.debug("**** main handleOnChange id: ".concat(id));
    let isEnabled = !playerSettings[id];
    if (isOverride) {
      isEnabled = isEnabledOverride;
    }
    const newPlayerSettingsData = _objectSpread(_objectSpread({}, playerSettings), {}, {
      [id]: isEnabled
    });
    try {
      let res;
      if (isPlayerLoggedIn) {
        res = await putCustomersSettingsAsync([makeSetting(id, !playerSettings[id])]);
      } else {
        const {
          c,
          i
        } = cAndI;
        res = await putCustomersSettingsAsync([makeSetting(id, !playerSettings[id])], c, i);
      }
      const {
        status,
        error
      } = res;
      if (error || status !== 'success') {
        svs.myProfile.logger.debug("**** handleOnChange id: ".concat(id, " error or status not success"), error);
        await showSettingsTechnicalError();
      } else {
        trackListChanges(newPlayerSettingsData, playerSettings, 'notifications');
        dispatch(setPlayerSettingsData(newPlayerSettingsData));
      }
    } catch (error) {
      svs.myProfile.logger.debug("**** handleOnChange id: ".concat(id, " error"), error);
      await showSettingsTechnicalError();
    }
  };
  const handleMultiCheckbox = async (ids, isEnabledBeforeChange, trackingName) => {
    svs.myProfile.logger.debug("**** main multicheckbox ids: ".concat(ids));
    const newSettings = ids;
    const newSettingsArr = [];
    Object.keys(ids).forEach(key => {
      newSettingsArr.push(makeSetting(key, ids[key]));
    });
    const newPlayerSettingsData = _objectSpread(_objectSpread({}, playerSettings), newSettings);
    try {
      let res;
      if (isPlayerLoggedIn) {
        res = await putCustomersSettingsAsync(newSettingsArr);
      } else {
        const {
          c,
          i
        } = cAndI;
        res = await putCustomersSettingsAsync(newSettingsArr, c, i);
      }
      const {
        status,
        error
      } = res;
      if (error || status !== 'success') {
        svs.myProfile.logger.debug("**** multicheckbox ids: ".concat(ids, ". Error or status not success"), error);
        await showSettingsTechnicalError();
      } else {
        trackNotification(trackingName, !isEnabledBeforeChange);
        dispatch(setPlayerSettingsData(newPlayerSettingsData));
      }
    } catch (error) {
      svs.myProfile.logger.debug("**** multicheckbox ids: ".concat(ids, " error"), error);
      await showSettingsTechnicalError();
    }
  };
  const handleSyndicateCbx = async id => {
    svs.myProfile.logger.debug("**** main handleSyndicateCbx id: ".concat(id));
    const notification = playerSyndicateData.find(item => item.mailTypeId === id);
    const checked = notification.transports.find(item => item.transportType === 'mailNotification');
    const mailNotification = notification.transports.findIndex(item => item.transportType === 'mailNotification');
    const transportType = {
      enabled: !checked.enabled,
      transportType: 'mailNotification'
    };
    const transportArray = notification.transports.slice();
    transportArray[mailNotification] = transportType;
    const newNotification = _objectSpread(_objectSpread({}, notification), {}, {
      transports: transportArray
    });
    if (isPlayerLoggedIn) {
      try {
        const {
          status,
          error
        } = await notificationsSyndicateService.putCustomersSyndicateAsync(newNotification);
        if (error || status !== 'success') {
          svs.myProfile.logger.debug('handleSyndicateCbx: error: ', error);
          showSettingsTechnicalError();
        } else {
          svs.myProfile.logger.debug("handleSyndicateCbx: success :)");
          const notificationIndex = playerSyndicateData.findIndex(item => item.mailTypeId === id);
          const newPlayerSyndicateData = playerSyndicateData.slice();
          newPlayerSyndicateData[notificationIndex] = newNotification;
          trackListChanges(newPlayerSyndicateData, playerSyndicateData, 'syndicate');
          setPlayerSyndicateData(newPlayerSyndicateData);
        }
      } catch (error) {
        showSettingsTechnicalError();
        svs.myProfile.logger.debug('handleSyndicateCbx: catch: error: ', error);
      }
    }
  };
  return React.createElement("div", {
    className: "margin-bottom-4"
  }, React.createElement(Form, null, !playerSettings && React.createElement(NotificationsSkeleton, null), playerSettings && React.createElement(CorrectionMail, {
    handleMultiCheckbox: handleMultiCheckbox,
    model: playerSettings
  }, React.createElement("div", null, React.createElement(CheckboxItem, {
    id: backendName.RECURRING_WAGER_REMINDERS,
    model: playerSettings,
    onChange: handleCheckbox,
    title: "P\xE5minnelsemejl n\xE4r dina flerveckorsspel beh\xF6ver f\xF6rl\xE4ngas"
  })), isPlayerLoggedIn && React.createElement(AppNotifications, null)), isPlayerLoggedIn && React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(TopHeader, {
    icon: icons.PLAYTOGETHER,
    title: titles.PLAYTOGETHER
  }), playerSyndicateData && React.createElement(SyndicateInformation, {
    isSyndicateMember: isSyndicateMember,
    isSyndicateOwner: isSyndicateOwner
  }), playerSyndicateData && isSyndicateMember && React.createElement(Section, {
    title: "Medlem"
  }, React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.BET,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Lagda spel"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.CANCEL_BET,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Annullerade spel"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.WITHDRAWAL,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Utbetalningar"
  })), React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.TERMINATED,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Avslutat lag"
  })), playerSyndicateData && isSyndicateOwner && React.createElement("div", {
    className: isSyndicateOwner && isSyndicateMember ? 'padding-top' : ''
  }, React.createElement(Section, {
    title: "Lagledare"
  }, React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.DEPOSIT,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Ins\xE4ttningar"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.WITHDRAWAL_BY_MEM,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Uttag"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.ACCEPT_INVITATION,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Inbjuden tackar ja"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.REMOVED_MEMBER_OWN,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Medlem l\xE4mnar lag"
  })), React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.INACTIVATED_OWN,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Medlem s\xE4tter sig vilande"
  }))), React.createElement(Marketplace, {
    setShouldShowApiError: setShouldShowApiError
  }))));
};
svs.myProfile.react.pages.notifications.Notifications = Notifications;

 })(window);